/** @format */
import { Injectable } from '@angular/core';
import { UrlService } from '@uirouter/core';
import { CeeposPayment, CeeposPaymentConfirmation, CeeposStatus } from 'common-typescript/types';

@Injectable({
    providedIn: 'root',
})
export class CeeposPaymentService {
    constructor(private urlService: UrlService) {}

    readCeeposResponseFromQueryParams(): Partial<CeeposPaymentConfirmation> {
        const search = this.urlService.search();

        return {
            Id: search.Id,
            Status: <CeeposStatus>this.convertQueryParamToInteger(search.Status),
            Reference: search.Reference,
            Hash: search.Hash,
            Payments: this.parsePayments(search.PaymentMethod, search.PaymentSum, search.Timestamp, search.PaymentDescription),
        };
    }

    private convertQueryParamToInteger(param: string): number {
        // params are sent as string so convert them to integer
        const num = Number.parseInt(param, 10);
        return Number.isNaN(num) ? undefined : num;
    }

    private parsePayments(paymentMethod: any, paymentSum: any, timestamp: any, paymentDescription: any): CeeposPayment[] {
        if ([paymentMethod, paymentSum, timestamp, paymentDescription].every(Array.isArray)) {
            return paymentMethod.map((method: any, i: number) => ({
                PaymentMethod: this.convertQueryParamToInteger(method),
                PaymentSum: this.convertQueryParamToInteger(paymentSum[i]),
                Timestamp: timestamp[i],
                PaymentDescription: paymentDescription[i],
            }));
        }

        if ([paymentMethod, paymentSum, timestamp, paymentDescription].every(value => !value || typeof value === 'string')) {
            return [
                {
                    PaymentMethod: this.convertQueryParamToInteger(paymentMethod),
                    PaymentSum: this.convertQueryParamToInteger(paymentSum),
                    Timestamp: timestamp,
                    PaymentDescription: paymentDescription,
                },
            ].filter(payment => Object.values(payment).some(el => el !== undefined));
        }

        return [];
    }
}
